import React, {useState, useEffect} from 'react'
import ReactPlayer from 'react-player'
import cn from "classnames"
import pageBg from  '../../img/camp-bg.webp'
import modalBg from '../../img/after-game-modal-bg-1.svg'
import backpage from '../../img/after-game-item-5.png'
import video1 from '../../img/game-5-video-1.mp4'
import video2 from '../../img/game-5-video-2.mp4'
import videoBg1 from '../../img/game-5-video-bg-1.png'
import videoBg2 from '../../img/game-5-video-bg-2.png'
import {Preloader, SpriteSvg, SideParameters} from '../../components'

const AfterCampPage = ({
	handleNextPage,
	name,
	isLoaded,
	setIsLoaded,
	setIsPlayMusic,
	mapPage,
}) => {

const [isVisibleContent, setIsVisibleContent] = useState(false)
const [modalContentChange, setModalContentChange] = useState(false)
	const [playFirst, setPlayFirst] = useState(false)
	const [playSecond, setPlaySecond] = useState(false)

	const handlePlayFirst = () => {
		if (!playFirst) {
			window.musicNeedPlay = window.musicPlay;
			setPlayFirst(true)
			setIsPlayMusic(false)
		} else {
			setPlayFirst(false)
			setIsPlayMusic(window.musicNeedPlay)
		}
	}
	const handlePlaySecond = () => {
		if (!playSecond) {
			window.musicNeedPlay = window.musicPlay;
			setPlaySecond(true)
			setIsPlayMusic(false)
		} else {
			setPlaySecond(false)
			setIsPlayMusic(window.musicNeedPlay)
		}
	}

	useEffect(()=> {
		setTimeout(()=> {
			setIsVisibleContent(true)
		},1000)
	},[])

	return (
		<>
		<Preloader isLoaded={isLoaded} setIsLoaded={setIsLoaded} time={1000}/>

		<div className={cn(
					 'full-page',
					 'after-trail-page',
					 isLoaded && 'active'
				 )}>

			<div className={cn(
				'full-video-wrap',
				playFirst && 'active')}>
				<div onClick={() => handlePlayFirst()} className="play-btn">
					<SpriteSvg width='60px' height='60px' id='video-stop-btn'/>
				</div>
				<ReactPlayer
					url={video1}
					width='100%'
					height='100%'
					playing={playFirst}
					playsinline
					muted={false}
					controls={false}
				/>
			</div>

			<div className={cn(
				'full-video-wrap',
				playSecond && 'active')}>
				<div onClick={() => handlePlaySecond()} className="play-btn">
					<SpriteSvg width='60px' height='60px' id='video-stop-btn'/>
				</div>
				<ReactPlayer
					url={video2}
					width='100%'
					height='100%'
					playsinline
					playing={playSecond}
					muted={false}
					controls={false}
				/>
			</div>

			<SideParameters
				knowledge={4}
				skill={4}
				exp={4}
				dexterity={4}
				strong={4}

				knowledgeUp={false}
				skillUp={false}
				expUp={true}
				dexterityUp={true}
				strongUp={true}
			/>

			<div className="page-bg">
				<img className='bg-img' src={pageBg} alt=""/>
			</div>

			<div className={cn(
						 'page-content',
						 isVisibleContent &&
						 'active'
					 )}>

				<div className={cn(
							 'modal',
					modalContentChange && 'disabled'
						 )}
				>
					<div className="modal-bg">
						<img src={modalBg} alt=""/>
					</div>
					<div className="modal-img">
						<img src={backpage} alt=""/>
					</div>


					<div className={cn(
						'modal-content'
					)}
					>
						<div className="modal-stage">
							<p>5/6</p>
						</div>
						<div className="increase-features">
							<div className="title">
								<p>Поздравляем!</p>
							</div>
							<div className="feature-list">
								<div className="btn green feature-item">
									<SpriteSvg id='feature-knowledge-bg'/>
									<p>+ опыт</p>
								</div>

								<div className="btn green feature-item">
									<SpriteSvg id='feature-experience-bg'/>
									<p>+ сила</p>
								</div>

								<div className="btn green feature-item">
									<SpriteSvg id='feature-skill-bg'/>
									<p>+ ловкость</p>
								</div>

							</div>
						</div>
						<div className="text">
							<p className='mg-b-24'>Тебе чудом повезло! Девушки были так восхищены твоей силой, что сделали подарок.</p>
							<p className='mg-b-24'>Специально для тебя!</p>
						</div>

						<div className="btn-wrap jcs">
							<div onClick={()=> setModalContentChange(true)} className="btn green mg-r-16" style={{width: '250px'}}>
								<SpriteSvg id='after-game-page-btn-green-bg'/>
								<span>Подарок от девушек</span>
							</div>

							<div onClick={()=> handleNextPage(mapPage)} className="btn border-green" style={{width: '180px'}}>
								<SpriteSvg id='after-game-page-btn-border-bg'/>
								<span>На карту</span>
							</div>
						</div>
					</div>

				</div>

				<div className={cn(
					'content',
					'center',
					!modalContentChange && 'disabled'
				)}>
					<div className="video-wrap">
						<div className="grid-12 mg-b-50">
							<div className="video x6 testVideo">
								<div onClick={() => handlePlayFirst()} className="play-btn first">
									<SpriteSvg width='60px' height='60px' id='video-play-btn'/>
								</div>
								<img className='mountain' src={videoBg1} alt=""/>
							</div>
							<div className="video x6">
								<div onClick={() => handlePlaySecond()} className="play-btn first">
									<SpriteSvg width='60px' height='60px' id='video-play-btn'/>
								</div>
								<img className='mountain' src={videoBg2} alt=""/>
							</div>
						</div>

						<div className="btn-wrap jcc">
							<div onClick={()=> handleNextPage(mapPage)} className="btn green" style={{width: '180px'}}>
								<SpriteSvg id='after-game-page-btn-green-bg'/>
								<span>На карту</span>
							</div>
						</div>
					</div>
				</div>

			</div>

		</div>
		</>
	)
}

export default AfterCampPage